// extracted by mini-css-extract-plugin
module.exports = {"btn-google-login":"index__btn-google-login__3ZXjT","container-btn-google":"index__container-btn-google__3bb0G"};